import React from 'react';

const LogoSmallIconV2 = ({
  className,
  style,
  active
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "20",
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16 2.32231C16 2.26601 16 2.22378 16 2.16749C16 2.11119 16 2.06896 16 2.01267V0H11.5788V2.01267C11.5788 2.06896 11.5788 2.11119 11.5788 2.16749C11.5788 2.22378 11.5788 2.26601 11.5788 2.32231V7.83955H4.42124V2.32231C4.42124 2.28008 4.42124 2.22379 4.42124 2.18156C4.42124 2.13934 4.42124 2.08304 4.42124 2.04082V0.0140755H0V2.04082C0 2.08304 0 2.13934 0 2.18156C0 2.22379 0 2.28008 0 2.32231V17.6918C0 17.734 0 17.7903 0 17.8325C0 17.8747 0 17.931 0 17.9733V20H4.42124V17.9733C4.42124 17.931 4.42124 17.8747 4.42124 17.8325C4.42124 17.7903 4.42124 17.734 4.42124 17.6918V12.1745L7.9928 10.007L11.5644 12.1604V17.6777C11.5644 17.734 11.5644 17.7762 11.5644 17.8325C11.5644 17.8888 11.5644 17.931 11.5644 17.9873V20H15.9856V17.9873C15.9856 17.931 15.9856 17.8888 15.9856 17.8325C15.9856 17.7762 15.9856 17.734 15.9856 17.6777V2.32231H16Z",
      fill: "#02F7FD"
    }
  )
);

export { LogoSmallIconV2 };
//# sourceMappingURL=LogoSmallIconV2.js.map
